import { Component, HostListener, OnInit } from '@angular/core';
import { AbonnementService, EtatAbonnement } from 'src/app/core/services/entities/abonnement.service';
import { RoleUtil } from './role.util';

/**
 * Bandeau d'abonnement en haut de l'application : à renouveler (délai de grâce) ou lecture seule.
 * S'affiche aussi dès qu'une saisie est refusée en 402 par le serveur.
 */
@Component({
  selector: 'bay-bandeau-abonnement',
  template: `
    <div *ngIf="visible" class="px-3 py-2 d-flex flex-wrap align-items-center gap-2" role="status" data-etat="bandeau-abonnement"
         [style.background]="lectureSeule ? '#fee2e2' : '#fef3c7'" [style.color]="lectureSeule ? '#991b1b' : '#92400e'" style="font-size:14px;">
      <span class="material-symbols-outlined" style="font-size:18px;" aria-hidden="true">{{ lectureSeule ? 'lock' : 'schedule' }}</span>
      <span class="flex-grow-1">{{ message }}</span>
      <a *ngIf="peutPayer" routerLink="/abonnement" class="btn btn-sm" [class.btn-danger]="lectureSeule" [class.btn-warning]="!lectureSeule">Renouveler</a>
    </div>
  `
})
export class BandeauAbonnementComponent implements OnInit {
  etat: EtatAbonnement | null = null;
  bloqueParServeur = false;
  readonly peutPayer = RoleUtil.gereExploitation();

  constructor(private service: AbonnementService) {}

  ngOnInit(): void {
    if (RoleUtil.estContenu()) return;
    this.service.etat().subscribe({ next: e => this.etat = e, error: () => this.etat = null });
  }

  @HostListener('window:abonnement-expire')
  surRefus(): void {
    this.bloqueParServeur = true;
  }

  get lectureSeule(): boolean {
    return this.bloqueParServeur || (this.etat?.statut === 'LECTURE_SEULE' && !!this.etat?.blocageApplique);
  }

  get visible(): boolean {
    return this.lectureSeule || this.etat?.statut === 'GRACE';
  }

  get message(): string {
    if (this.lectureSeule) {
      return 'Abonnement expiré : la ferme est en lecture seule. Vos données restent consultables et exportables.'
        + (this.peutPayer ? '' : ' Demandez à l\'administrateur de renouveler l\'abonnement.');
    }
    const j = this.etat?.joursRestants;
    return `Abonnement à renouveler : ${j != null ? j + ' jour(s)' : 'quelques jours'} avant le passage en lecture seule.`;
  }
}
